import css from './skeletonCompletedMaintenanceEventItem.module.css'
import Skeleton from '@/shared/Loaders/Skeleton'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { Fragment } from 'react'

interface IProps {
  eventNumber?: number
}

const SkeletonCompletedMaintenanceEventList = ({ eventNumber = 7 }: IProps) => {
  const renderEventList = (index: number) => {
    return (
      <Fragment key={index}>
        <div className={css.wrapper}>
          <div className="flex-lines gap4">
            <Skeleton style={{ borderRadius: '4px' }} height="18px" width="90px" />
            <Skeleton style={{ borderRadius: '4px' }} height="16px" width={`${index % 2 === 0 ? 80 : 100}%`} />
            <Skeleton style={{ borderRadius: '4px' }} height="12px" width="120px" />
          </div>
          <div className="flex-lines gap12 mt8">
            <Skeleton style={{ borderRadius: '6px' }} height="54px" width="100%" />
            <Skeleton style={{ borderRadius: '8px' }} height="32px" width="70%" />
          </div>
        </div>
        {index !== eventNumber - 1 && <SeparateLine />}
      </Fragment>
    )
  }

  return <div className="100%">{Array.from({ length: eventNumber }).map((_, i) => renderEventList(i))}</div>
}

export default SkeletonCompletedMaintenanceEventList
